import { GetSpecializationsDto } from 'woofwoof-api';
import { GetSpecializationDto } from 'woofwoof-api-public';
import { translateKey } from 'src/locales/translate';


const SPECIALIZATION_MAPPING: Record<string, string> = {
  // Veterinarian specializations
  general_veterinarian: translateKey("search.category.veterinarian"),
  cardiology: 'Kardiologia',
  orthopaedics: 'Ortopedia',
  dermatology: 'Dermatologia',
  ophthalmology: 'Okulistyka',
  neurology: 'Neurologia',
  oncology: 'Onkologia',
  internal_medicine: translateKey("hardcoded.medycyna_wewnetrzna"),
  internist: 'Internista',
  surgery: 'Chirurgia',
  anesthesiology_and_pain_management: 'Anestezjologia',
  emergency_and_critical_care: 'Medycyna ratunkowa i intensywna terapia',
  dentistry: 'Stomatologia',
  clinical_pathology: 'Patologia kliniczna',
  pathology: 'Patologia',
  diagnostic_imaging: 'Diagnostyka obrazowa',
  animal_reproduction_theriogenology: translateKey("hardcoded.rozrod_zwierzat"),
  animal_behavior_and_welfare: 'Behawiorystyka',
  veterinary_nutrition: translateKey("hardcoded.zywienie_zwierzat"),
  parasitology: 'Parazytologia',
  public_health_and_food_safety: translateKey("hardcoded.zdrowie_publiczne_i_bezpieczenstwo_zywnosci"),
  geriatrics: 'Geriatria',
  prevention_and_vaccination: 'Profilaktyka i szczepienia',
  endocrinology: 'Endokrynologia',
  other: translateKey("search.specializationOther"),
  // Dietitian specializations
  general_dietitian: translateKey("search.category.dietitian"),
  weight_management: 'Kontrola wagi',
  nutritional_counseling: translateKey("hardcoded.doradztwo_zywieniowe"),
  allergy_diet: 'Diety eliminacyjne',
  therapeutic_nutrition: translateKey("hardcoded.zywienie_terapeutyczne"),
  feeding_plan: translateKey("hardcoded.plan_zywienia"),
  puppy_kitten_nutrition: translateKey("hardcoded.zywienie_szczeniat_i_kociat"),
  sports_working_dog_nutrition: translateKey("hardcoded.zywienie_sportowe_pracujace"),
  pregnancy_lactation_nutrition: translateKey("hardcoded.zywienie_w_ciazy_i_laktacji"),
  barf_home_diet: translateKey("hardcoded.zywienie_barf_i_diety_domowe"),
  // Behaviorist specializations
  general_behaviorist: translateKey("search.category.behaviorist"),
  aggression_management: translateKey("hardcoded.zarzadzanie_agresja"),
  anxiety_separation: translateKey("hardcoded.lek_separacyjny"),
  socialization: 'Socjalizacja',
  fear_phobias: translateKey("hardcoded.fobie_i_leki"),
  obedience_training: translateKey("hardcoded.trening_posluszenstwa"),
  house_soiling: translateKey("hardcoded.problemy_z_czystoscia"),
  hyperactivity_reactivity: translateKey("hardcoded.nadpobudliwosc_i_reaktywnosc"),
  introducing_animals: translateKey("hardcoded.laczenie_zwierzat_w_domu"),
  compulsive_behaviors: 'Zachowania kompulsywne',
  puppy_aptitude_testing: translateKey("hardcoded.testy_predyspozycji_szczeniat"),
  adoption_preparation: 'Przygotowanie do adopcji',
  preparing_for_baby: translateKey("hardcoded.przygotowanie_na_pojawienie_sie_dziecka"),
  walking_problems: 'Problemy spacerowe',
  resource_guarding: translateKey("hardcoded.obrona_zasobow"),
  destructive_behaviors: 'Zachowania destrukcyjne',
  adaptation_issues_after_changes: 'Problemy adaptacyjne po zmianach',
  adolescent_dog_support:
    translateKey("hardcoded.wsparcie_dla_psow_dorastajacych_okres_adolescencji"),
  pain_or_health_related_behavior: translateKey("hardcoded.problemy_zwiazane_z_bolem_zdrowiem"),
};

export function mapSpecializationNameIdToString(
  specialization: GetSpecializationsDto | GetSpecializationDto | string,
): string {
  if (typeof specialization === 'string') {
    return SPECIALIZATION_MAPPING[specialization] || specialization;
  }

  if ('name' in specialization && specialization.name) {
    return SPECIALIZATION_MAPPING[specialization.name] || specialization.name;
  }

  return 'Unknown specialization';
}
